module.exports = __webpack_public_path__ + "media/images/top-page_reserve@1x-bf7f0547933dc929d7ebbf44ef8e50c9.jpg";